import { recordArtifactDeleted } from '@streem/analytics';
import { StreemAPI } from '@streem/api';
import { invariant } from '@streem/toolbox';
import { map, shareReplay } from 'rxjs/operators';
import { WallItem } from 'streem-sdk-protobuf';
import { fetchDownloadUrl } from '../../util/fetch_download_url';
import { logger } from '../../util/logger';
import { artifactTimedDeletion } from '../../util/rx/artifact_timed_deletion';
import { firstFromGroup } from '../../util/rx/first_from_group';
import { accumulateAndTransformWallEvents, filterByProperty, findInGroup } from '../wall/utils';
export class RecordingController {
    constructor(config) {
        this.config = config;
        this.recordings = this.config.roomWall.itemsByType.pipe(findInGroup('artifact'), accumulateAndTransformWallEvents('artifact', async (artifact) => {
            if (artifact.artifactType !== WallItem.ArtifactType.RECORDING)
                return artifact;
            if (!artifact.recording)
                return artifact;
            invariant(artifact.recording.storageUrl || artifact.recording.previewStorageUrl, 'Recording must have storage URL');
            const ready = artifact.status === WallItem.Artifact.Status.FULFILLED;
            if (!ready && artifact.recording.previewStorageUrl) {
                artifact.recording.previewDownloadUrl = await fetchDownloadUrl(this.config.context.roomId, artifact.recording.previewStorageUrl);
            }
            else if (ready && artifact.recording.storageUrl) {
                artifact.recording.downloadUrl = await fetchDownloadUrl(this.config.context.roomId, artifact.recording.storageUrl);
            }
            return artifact;
        }), filterByProperty('artifactType', WallItem.ArtifactType.RECORDING), shareReplay(1));
        this.recordingStatus = this.recordings.pipe(firstFromGroup(), map(recordingArtifact => recordingArtifact.recording.recordingStatus ?? undefined));
    }
    getRecording(id) {
        return this.recordings.pipe(filterByProperty('id', id.toString()), firstFromGroup());
    }
    async pauseRecording() {
        invariant(this.config.context.roomId, 'Expected room id to be defined when pausing recording');
        try {
            await StreemAPI.rooms.pauseRoomRecording(this.config.context.roomId.toString());
            logger.info(`Room ${this.config.context.roomId.toString()} recording paused`);
        }
        catch (e) {
            throw new Error(`Failed to pause recording for room ${this.config.context.roomId}`, e);
        }
    }
    async resumeRecording() {
        invariant(this.config.context.roomId, 'Expected room id to be defined when resuming recording');
        try {
            await StreemAPI.rooms.resumeRoomRecording(this.config.context.roomId.toString());
            logger.info(`Room ${this.config.context.roomId.toString()} recording resumed`);
        }
        catch (e) {
            throw new Error(`Failed to resume recording for room ${this.config.context.roomId}`, e);
        }
    }
    /**
     * Deletes a recording off of the backend
     * @param id The recording id to delete
     */
    async deleteRecording(id) {
        try {
            await StreemAPI.rooms.deleteRecording(this.config.context.roomId.toString(), id.toString());
            await artifactTimedDeletion(id.toString(), this.recordings);
            recordArtifactDeleted({
                artifactSid: id.toString(),
                roomSid: this.config.context.roomId.toString(),
                recording: {},
            });
        }
        catch (e) {
            logger.error('Failed to delete recording: ', id.toString());
        }
    }
}
//# sourceMappingURL=recording_controller.js.map